module.exports = __webpack_public_path__ + "img/face-smirking.59869e85.svg";